import { Injectable } from "@angular/core";
import { ApiService } from "@bt/core";
import { CatalogsModel } from "./catalogs.model";
import { map } from "rxjs/operators";

@Injectable()
export class CatalogsService {
    constructor(private apiService: ApiService) { }

    private catalogs: CatalogsModel;

    init(): Promise<CatalogsModel> {
        return this.apiService
            .get<CatalogsModel>("api/catalogs")
            .pipe(map(x => x.data))
            .toPromise()
            .then(data => {
                this.catalogs = data;
                return data;
            });
    }

    public getPairs(): string[] {
        return this.catalogs.pairs;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/catalogs/catalogs.service.ts